import React, {
  createContext,
  useEffect,
  useState,
  ReactNode,
} from 'react';
import { v4 as uuidv4 } from 'uuid';
import { UAParser } from 'ua-parser-js';

export type CurrentDeviceContextType = {
  currentDeviceId: string | undefined;
  currentDeviceType: string | undefined;
};

const initialState = {
  currentDeviceId: undefined,
  currentDeviceType: undefined,
};

const CurrentDeviceContext = createContext<CurrentDeviceContextType>({
  ...initialState,
});

export const CurrentDeviceContextProvider = ({ children }: { children: ReactNode; }) => {
  const [currentDeviceId, setCurrentDeviceId] = useState<string | undefined>(initialState.currentDeviceId);
  const [currentDeviceType, setCurrentDeviceType] = useState<string | undefined>(initialState.currentDeviceType);

  useEffect(() => {
    const parser = new UAParser(window.navigator.userAgent);
    setCurrentDeviceId(getOrCreateDeviceId());
    setCurrentDeviceType(parser.getBrowser().name);
  }, []);

  const getOrCreateDeviceId = () => {
    let deviceId = localStorage.getItem('device_id');

    if (!deviceId) {
      deviceId = uuidv4();
      localStorage.setItem('device_id', deviceId);
    }

    return deviceId;
  }

  return (
    <CurrentDeviceContext.Provider
      value={{
        currentDeviceId,
        currentDeviceType,
      }}
    >
      {children}
    </CurrentDeviceContext.Provider>
  );
};

export default CurrentDeviceContext;
